import { fileHost } from './urls';

export const fileWithHost = fileUrl => {
    if (fileUrl.startsWith('http') || fileUrl.startsWith('https')) {
        return fileUrl;
    }
    if (fileUrl.startsWith('/')) {
        return `${fileHost}${fileUrl}`;
    }
    return `${fileHost}/${fileUrl}`;
};
